import Carousel from "react-bootstrap/Carousel";

function DarkVariantExample() {
  return (
    <Carousel
      id="carosel"
      data-bs-theme="dark"
      style={{ objectFit: "cover", overflow: "hidden" }}
      controls={false}
      indicators={false}
      interval={3000}
      pause={false}
    >
      <Carousel.Item>
        <img className="d-block w-75 mx-auto" src="img/appartamenti/1.png" alt="First slide" />
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-75 mx-auto" src="img/appartamenti/2.png" alt="Second slide" />
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-75 mx-auto" src="img/appartamenti/3.png" alt="Third slide" />
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-75 mx-auto" src="img/appartamenti/4.png" alt="Fourth slide" />
      </Carousel.Item>
    </Carousel>
  );
}

export default DarkVariantExample;
